import { Html5Qrcode } from 'html5-qrcode'
import React, { useCallback, useRef } from 'react'

type QRCodeProps = {
  onSuccess: (text: string) => void
  onError: (message: string) => void
  className?: string
}

const QRCode: React.FC<QRCodeProps> = ({ onSuccess, onError, className }) => {
  const htmlQrCode = useRef<Html5Qrcode | null>(null)

  const onSuccessRef = useRef(onSuccess)
  onSuccessRef.current = onSuccess

  const onErrorRef = useRef(onError)
  onErrorRef.current = onError

  const initQrCode = useCallback((element: HTMLDivElement | null) => {
    if (element) {
      const elementId = element.id || `qr-code-scanner-${Date.now()}`
      element.id = elementId

      htmlQrCode.current = new Html5Qrcode(elementId, {
        experimentalFeatures: undefined,
        formatsToSupport: undefined,
        verbose: undefined,
        useBarCodeDetectorIfSupported: true,
      })

      const config = { fps: 10, qrbox: { width: 250, height: 250 } }

      htmlQrCode.current
        .start(
          { facingMode: 'environment' },
          config,
          (text) => {
            onSuccessRef.current(text)
          },
          () => {
            htmlQrCode.current?.resume()
          }
        )
        .catch((e) => {
          onErrorRef.current(e)
        })
    } else {
      if (htmlQrCode.current?.isScanning) {
        htmlQrCode.current.stop().catch((error) => {
          console.error('Failed to stop html5Qrcode: ', error)
        })
      }
      htmlQrCode.current = null
    }
  }, [])

  return <div ref={initQrCode} className={className} />
}

export { QRCode }
